import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "replace",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.43822 0.701159C0.773947 0.377315 0 0.861025 0 1.60003V9.69263C0 10.1524 0.313528 10.553 0.759864 10.6634L9.34375 12.7868C9.46204 12.8024 9.54616 12.9116 9.53038 13.0286C9.51724 13.1248 9.44101 13.2002 9.34375 13.2132L0.759865 15.3366C0.313529 15.447 0 15.8476 0 16.3074V24.4C0 25.139 0.773949 25.6227 1.43822 25.2988L25.7056 13.468C25.9685 13.3406 26.0736 13.026 25.9448 12.7686C25.8922 12.6646 25.8081 12.5814 25.7056 12.532L1.43822 0.701159Z" })
});
export default SvgSendreact;
